import apiClient from "./axios.config";

const ongoingVendorService = {
  ongoingServicesBooking(formData) {
    return apiClient.post(`/vendors/booking/ongoing`, formData);
  },
  completeVendor(formData) {
    return apiClient.post(`/vendors/booking/completed`, formData);
  },
  cancelServicesBooking(bookingGuid) {
    return apiClient.post(`/vendors/booking/cancel/${bookingGuid}`);
  },
  markAsCompleteService(bookingGuid) {
    return apiClient.put(
      `/vendors/booking/mark-completed?bookingGuid=${bookingGuid}`
    );
  },
  requoteService(bookingGuid, requoteAmount) {
    return apiClient.put(
      `/vendors/booking/requote?bookingGuid=${bookingGuid}&requoteAmount=${requoteAmount}`
    );
  },
  bookingDetails(bookingGuid) {
    return apiClient.get(`/vendors/booking/${bookingGuid}`);
  },
};

export default ongoingVendorService;
